const createCouponLocale = ({ reveal, entry, errors }) => ({
  ng: {
    coupon: {
      reveal,
      entry,
      errors,
    },
  },
});

const newgameCoupon = {
  th: createCouponLocale({
    reveal: {
      credit: "เครดิตฟรี",
      points: "คะแนน",
      freeSpins: "ฟรีสปิน",
      specialReward: "รางวัลพิเศษ",
      creditEyebrow: "รางวัลเครดิตฟรี",
      pointsEyebrow: "รางวัลคะแนน",
      freeSpinsEyebrow: "รางวัลฟรีสปิน",
      rewardEyebrow: "ปลดล็อกรางวัลแล้ว",
      close: "ปิดหน้ารางวัล",
      congratulations: "ยินดีด้วย!",
      opened: "คูปองของคุณเปิดรางวัลแล้ว",
      freeSpinCard: "การ์ดรางวัลฟรีสปิน เกม {{game}}",
      freeSpinGame: "เกมฟรีสปิน",
      gameImage: "ภาพเกม {{game}}",
      artwork: "ภาพเกม",
      epicFreeSpin: "ระดับพิเศษ • ฟรีสปิน",
      receivedGame: "เกมที่ได้รับ",
      yourFreeSpinGame: "เกมฟรีสปินของคุณ",
      openGame: "เปิดเกมรับฟรีสปิน",
      playLater: "ไว้เล่นภายหลัง",
      claim: "รับรางวัล",
    },
    entry: {
      eyebrow: "คูปองรางวัล",
      title: "เปิดคูปองรับรางวัล",
      intro:
        "ใส่โค้ดเพียงครั้งเดียว ระบบจะตรวจสอบเครดิตฟรี คะแนน หรือฟรีสปินให้อัตโนมัติ",
      placeholder: "ใส่รหัสคูปอง",
      codeAria: "รหัสคูปอง",
      reward: "รางวัล",
      receivedGame: "เกมที่ได้รับ",
      success: "รับรางวัลสำเร็จ รางวัลถูกเพิ่มเข้าบัญชีแล้ว",
      pending:
        "กำลังตรวจสอบผลกับผู้ให้บริการ ระบบเก็บหมายเลขรายการเดิมไว้แล้ว กรุณาอย่าใส่โค้ดซ้ำ",
      failedReleased: "ไม่สามารถแจกรางวัลได้ และระบบคืนสิทธิ์ของโค้ดแล้ว",
      openGame: "เปิดเกมรับฟรีสปิน",
      check: "ตรวจสอบคูปอง",
      confirm: "ยืนยันเปิดรางวัล",
      another: "ใช้คูปองอื่น",
    },
    errors: {
      unknown: "ระบบกำลังตรวจสอบผลรางวัล กรุณาอย่าใช้โค้ดซ้ำ",
      default: "ไม่สามารถทำรายการคูปองได้ กรุณาลองใหม่อีกครั้ง",
      network:
        "ไม่สามารถเชื่อมต่อระบบคูปองได้ กรุณาตรวจสอบอินเทอร์เน็ตแล้วลองใหม่อีกครั้ง",
      freeSpinUnavailable: "คูปองฟรีสปินนี้ยังไม่พร้อมใช้งาน กรุณาติดต่อฝ่ายบริการ",
      freeSpinLegacy: "คูปองฟรีสปินต้องใช้ระบบคูปองเวอร์ชันใหม่",
      alreadyRedeemed: "คุณใช้คูปองนี้ไปแล้ว",
      alreadyReserved: "คูปองนี้กำลังอยู่ระหว่างดำเนินการ กรุณารอสักครู่",
      codeRequired: "กรุณากรอกรหัสคูปอง",
      codeUnavailable: "คูปองนี้ถูกใช้ไปแล้วหรือไม่พร้อมใช้งาน",
      configChanged: "ข้อมูลคูปองมีการเปลี่ยนแปลง กรุณาตรวจสอบคูปองอีกครั้ง",
      expired: "คูปองนี้หมดอายุแล้ว",
      inactive: "คูปองนี้ยังไม่เปิดใช้งาน",
      notFound: "ไม่พบคูปองนี้ กรุณาตรวจสอบรหัสอีกครั้ง",
      notStarted: "คูปองนี้ยังไม่ถึงเวลาใช้งาน",
      quotaExhausted: "สิทธิ์ของคูปองนี้ถูกใช้ครบแล้ว",
      redemptionFailed: "รับรางวัลจากคูปองไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
      rewardTypeInvalid: "ประเภทของรางวัลไม่ถูกต้อง กรุณาติดต่อฝ่ายบริการ",
      rewardTypeMismatch: "ประเภทของรางวัลไม่ตรงกับคูปอง กรุณาตรวจสอบอีกครั้ง",
      memberNotFound: "ไม่พบข้อมูลสมาชิก กรุณาเข้าสู่ระบบใหม่",
      memberSessionRequired: "กรุณาเข้าสู่ระบบอีกครั้ง",
      redemptionNotFound: "ไม่พบรายการรับรางวัล กรุณาตรวจสอบคูปองอีกครั้ง",
      requestIdUsed: "ไม่สามารถดำเนินรายการนี้ได้ กรุณาตรวจสอบคูปองอีกครั้ง",
    },
  }),
  en: createCouponLocale({
    reveal: {
      credit: "Free credit",
      points: "Points",
      freeSpins: "Free spins",
      specialReward: "Special reward",
      creditEyebrow: "Free credit reward",
      pointsEyebrow: "Points reward",
      freeSpinsEyebrow: "Free spin reward",
      rewardEyebrow: "Reward unlocked",
      close: "Close reward",
      congratulations: "Congratulations!",
      opened: "Your coupon reward is now open",
      freeSpinCard: "Free-spin reward card for {{game}}",
      freeSpinGame: "Free-spin game",
      gameImage: "{{game}} game artwork",
      artwork: "Game artwork",
      epicFreeSpin: "Epic • Free spin",
      receivedGame: "Game received",
      yourFreeSpinGame: "Your free-spin game",
      openGame: "Open game and use free spins",
      playLater: "Play later",
      claim: "Claim reward",
    },
    entry: {
      eyebrow: "Reward coupon",
      title: "Open a reward coupon",
      intro:
        "Enter the code once. We will automatically check for free credit, points, or free spins.",
      placeholder: "Enter coupon code",
      codeAria: "Coupon code",
      reward: "Reward",
      receivedGame: "Game received",
      success: "Reward claimed successfully and added to your account",
      pending:
        "The provider is confirming the result. We kept the same request number; do not enter the code again.",
      failedReleased: "The reward could not be issued, and the coupon is available again.",
      openGame: "Open game and use free spins",
      check: "Check coupon",
      confirm: "Open reward",
      another: "Use another coupon",
    },
    errors: {
      unknown: "We are checking the reward result. Do not use the code again.",
      default: "The coupon request could not be completed. Please try again.",
      network: "Cannot reach the coupon service. Check your connection and try again.",
      freeSpinUnavailable: "This free-spin coupon is not ready. Please contact support.",
      freeSpinLegacy: "Free-spin coupons require the new coupon system.",
      alreadyRedeemed: "You have already used this coupon",
      alreadyReserved: "This coupon is being processed. Please wait a moment.",
      codeRequired: "Enter a coupon code",
      codeUnavailable: "This coupon has been used or is unavailable",
      configChanged: "The coupon details changed. Please check the coupon again.",
      expired: "This coupon has expired",
      inactive: "This coupon is not active",
      notFound: "Coupon not found. Check the code and try again.",
      notStarted: "This coupon is not available yet",
      quotaExhausted: "All available uses of this coupon have been claimed",
      redemptionFailed: "The coupon reward could not be claimed. Please try again.",
      rewardTypeInvalid: "The reward type is invalid. Please contact support.",
      rewardTypeMismatch: "The reward type does not match this coupon. Please check again.",
      memberNotFound: "Member information was not found. Please sign in again.",
      memberSessionRequired: "Please sign in again",
      redemptionNotFound: "Reward claim not found. Please check the coupon again.",
      requestIdUsed: "This request cannot continue. Please check the coupon again.",
    },
  }),
  cn: createCouponLocale({
    reveal: {
      credit: "免费余额",
      points: "积分",
      freeSpins: "免费旋转",
      specialReward: "特别奖励",
      creditEyebrow: "免费余额奖励",
      pointsEyebrow: "积分奖励",
      freeSpinsEyebrow: "免费旋转奖励",
      rewardEyebrow: "奖励已解锁",
      close: "关闭奖励窗口",
      congratulations: "恭喜！",
      opened: "您的优惠券奖励已开启",
      freeSpinCard: "{{game}} 免费旋转奖励卡",
      freeSpinGame: "免费旋转游戏",
      gameImage: "{{game}} 游戏图片",
      artwork: "游戏图片",
      epicFreeSpin: "史诗级 • 免费旋转",
      receivedGame: "获得的游戏",
      yourFreeSpinGame: "您的免费旋转游戏",
      openGame: "打开游戏使用免费旋转",
      playLater: "稍后再玩",
      claim: "领取奖励",
    },
    entry: {
      eyebrow: "奖励优惠券",
      title: "开启优惠券奖励",
      intro: "只需输入一次代码，系统会自动检查免费余额、积分或免费旋转奖励。",
      placeholder: "输入优惠券代码",
      codeAria: "优惠券代码",
      reward: "奖励",
      receivedGame: "获得的游戏",
      success: "奖励领取成功，已添加到您的账户",
      pending: "提供商正在确认结果。系统已保留原请求编号，请勿重复输入代码。",
      failedReleased: "奖励无法发放，优惠券使用资格已恢复。",
      openGame: "打开游戏使用免费旋转",
      check: "检查优惠券",
      confirm: "开启奖励",
      another: "使用其他优惠券",
    },
    errors: {
      unknown: "系统正在检查奖励结果，请勿重复使用代码。",
      default: "无法完成优惠券操作，请重试。",
      network: "无法连接优惠券服务，请检查网络后重试。",
      freeSpinUnavailable: "此免费旋转优惠券尚未就绪，请联系客服。",
      freeSpinLegacy: "免费旋转优惠券需要使用新版优惠券系统。",
      alreadyRedeemed: "您已使用过此优惠券",
      alreadyReserved: "此优惠券正在处理中，请稍候。",
      codeRequired: "请输入优惠券代码",
      codeUnavailable: "此优惠券已被使用或不可用",
      configChanged: "优惠券信息已更改，请重新检查。",
      expired: "此优惠券已过期",
      inactive: "此优惠券尚未启用",
      notFound: "找不到此优惠券，请检查代码。",
      notStarted: "此优惠券尚未到使用时间",
      quotaExhausted: "此优惠券的可用名额已用完",
      redemptionFailed: "领取优惠券奖励失败，请重试。",
      rewardTypeInvalid: "奖励类型无效，请联系客服。",
      rewardTypeMismatch: "奖励类型与优惠券不匹配，请重新检查。",
      memberNotFound: "找不到会员信息，请重新登录。",
      memberSessionRequired: "请重新登录",
      redemptionNotFound: "找不到奖励领取记录，请重新检查优惠券。",
      requestIdUsed: "无法继续此操作，请重新检查优惠券。",
    },
  }),
  mm: createCouponLocale({
    reveal: {
      credit: "အခမဲ့ခရက်ဒစ်",
      points: "ပွိုင့်",
      freeSpins: "အခမဲ့လှည့်ခွင့်",
      specialReward: "အထူးဆု",
      creditEyebrow: "အခမဲ့ခရက်ဒစ်ဆု",
      pointsEyebrow: "ပွိုင့်ဆု",
      freeSpinsEyebrow: "အခမဲ့လှည့်ခွင့်ဆု",
      rewardEyebrow: "ဆုကို ဖွင့်ပြီးပါပြီ",
      close: "ဆုမျက်နှာပြင်ပိတ်ရန်",
      congratulations: "ဂုဏ်ယူပါသည်!",
      opened: "သင့်ကူပွန်ဆုကို ဖွင့်ပြီးပါပြီ",
      freeSpinCard: "{{game}} အတွက် အခမဲ့လှည့်ခွင့်ဆုကတ်",
      freeSpinGame: "အခမဲ့လှည့်ခွင့်ဂိမ်း",
      gameImage: "{{game}} ဂိမ်းပုံ",
      artwork: "ဂိမ်းပုံ",
      epicFreeSpin: "အထူးအဆင့် • အခမဲ့လှည့်ခွင့်",
      receivedGame: "ရရှိသောဂိမ်း",
      yourFreeSpinGame: "သင့်အခမဲ့လှည့်ခွင့်ဂိမ်း",
      openGame: "ဂိမ်းဖွင့်ပြီး အခမဲ့လှည့်ခွင့်သုံးရန်",
      playLater: "နောက်မှကစားမည်",
      claim: "ဆုယူရန်",
    },
    entry: {
      eyebrow: "ဆုကူပွန်",
      title: "ကူပွန်ဖွင့်ပြီး ဆုယူရန်",
      intro:
        "ကုဒ်ကို တစ်ကြိမ်သာထည့်ပါ။ အခမဲ့ခရက်ဒစ်၊ ပွိုင့် သို့မဟုတ် အခမဲ့လှည့်ခွင့်ကို အလိုအလျောက်စစ်ဆေးပေးမည်။",
      placeholder: "ကူပွန်ကုဒ်ထည့်ပါ",
      codeAria: "ကူပွန်ကုဒ်",
      reward: "ဆု",
      receivedGame: "ရရှိသောဂိမ်း",
      success: "ဆုယူပြီး အကောင့်ထဲသို့ ထည့်ပြီးပါပြီ",
      pending:
        "ပံ့ပိုးသူထံမှ ရလဒ်ကိုစစ်ဆေးနေသည်။ မူလစာရင်းနံပါတ်ကို သိမ်းထားပြီးဖြစ်၍ ကုဒ်ထပ်မထည့်ပါနှင့်။",
      failedReleased: "ဆုမပေးနိုင်သဖြင့် ကူပွန်အသုံးပြုခွင့်ကို ပြန်ဖွင့်ပေးထားသည်။",
      openGame: "ဂိမ်းဖွင့်ပြီး အခမဲ့လှည့်ခွင့်သုံးရန်",
      check: "ကူပွန်စစ်ဆေးရန်",
      confirm: "ဆုဖွင့်ရန်",
      another: "အခြားကူပွန်သုံးရန်",
    },
    errors: {
      unknown: "ဆုရလဒ်ကို စစ်ဆေးနေသည်။ ကုဒ်ကို ထပ်မသုံးပါနှင့်။",
      default: "ကူပွန်လုပ်ငန်း မပြီးမြောက်နိုင်ပါ။ ထပ်မံကြိုးစားပါ။",
      network: "ကူပွန်စနစ်သို့ မချိတ်ဆက်နိုင်ပါ။ အင်တာနက်စစ်ပြီး ထပ်ကြိုးစားပါ။",
      freeSpinUnavailable: "ဤအခမဲ့လှည့်ခွင့်ကူပွန် အသင့်မဖြစ်သေးပါ။ ဝန်ဆောင်မှုအဖွဲ့ကို ဆက်သွယ်ပါ။",
      freeSpinLegacy: "အခမဲ့လှည့်ခွင့်ကူပွန်သည် ကူပွန်စနစ်အသစ် လိုအပ်သည်။",
      alreadyRedeemed: "ဤကူပွန်ကို သင်အသုံးပြုပြီးပါပြီ",
      alreadyReserved: "ဤကူပွန်ကို လုပ်ဆောင်နေသည်။ ခဏစောင့်ပါ။",
      codeRequired: "ကူပွန်ကုဒ်ထည့်ပါ",
      codeUnavailable: "ဤကူပွန်ကို အသုံးပြုပြီး သို့မဟုတ် မရနိုင်တော့ပါ",
      configChanged: "ကူပွန်အချက်အလက် ပြောင်းလဲသွားသည်။ ပြန်စစ်ပါ။",
      expired: "ဤကူပွန် သက်တမ်းကုန်ပြီ",
      inactive: "ဤကူပွန်ကို ဖွင့်မထားသေးပါ",
      notFound: "ကူပွန်မတွေ့ပါ။ ကုဒ်ကို ပြန်စစ်ပါ။",
      notStarted: "ဤကူပွန် အသုံးပြုချိန် မရောက်သေးပါ",
      quotaExhausted: "ဤကူပွန်၏ ရရှိနိုင်သောအခွင့်အရေးများ ပြည့်သွားပြီ",
      redemptionFailed: "ကူပွန်ဆု မယူနိုင်ပါ။ ထပ်ကြိုးစားပါ။",
      rewardTypeInvalid: "ဆုအမျိုးအစား မမှန်ပါ။ ဝန်ဆောင်မှုအဖွဲ့ကို ဆက်သွယ်ပါ။",
      rewardTypeMismatch: "ဆုအမျိုးအစားနှင့် ကူပွန် မကိုက်ညီပါ။ ပြန်စစ်ပါ။",
      memberNotFound: "အဖွဲ့ဝင်အချက်အလက် မတွေ့ပါ။ ပြန်ဝင်ပါ။",
      memberSessionRequired: "ပြန်လည်ဝင်ရောက်ပါ",
      redemptionNotFound: "ဆုယူစာရင်း မတွေ့ပါ။ ကူပွန်ကို ပြန်စစ်ပါ။",
      requestIdUsed: "ဤလုပ်ငန်းကို ဆက်မလုပ်နိုင်ပါ။ ကူပွန်ကို ပြန်စစ်ပါ။",
    },
  }),
};

export default newgameCoupon;
